import styled from 'styled-components';
import ValidationErrors from 'components/common/general/ValidationErrors';

export const ValidationErrorsStyled = styled(ValidationErrors)`
  margin-top: 8.4rem;
`;

export const FooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin: 0 auto;
  padding: 6.4rem 0 10rem;
`;
